import React from 'react';
import TextArea from '@atlaskit/textarea';
export const EditParagraph = ({
  value,
  isInvalid,
  onChange
}) => {
  return /*#__PURE__*/React.createElement(TextArea, {
    appearance: "standard",
    isCompact: false,
    isDisabled: false,
    isReadOnly: false,
    isInvalid: isInvalid,
    minimumRows: 5,
    maxHeight: "none",
    isMonospaced: false,
    value: value,
    defaultValue: undefined,
    resize: "smart",
    spellCheck: false,
    theme: undefined,
    onBlur: undefined,
    onChange: onChange,
    onFocus: undefined
  });
};